import React from "react";
import '../style/css/Loading.css'

const LoadingText = () => {

    return (
        <div className="contain">
            <span class="back">
                <span>L</span>
                <span>o</span>
                <span>a</span>
                <span>d</span>
                <span>i</span>
                <span>n</span>
                <span>g</span>
            </span>
        </div>
    )
}

export default LoadingText